import { set, sum } from "lodash";
import { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import api from "../../../services/api";
import ExcelDmae from "components/shared/excel/excel";

const columnsLabel = {
  HIDROMETRO: "Hidrômetro",
  CD_META_DEVICE_ADDR: "Nr. Equipamento Lora",
  LOCALIDADE: "Endereço",
  APARTAMENTO: "Apartamento",
  NR_EQUIPAMENTO: "Equipamento",
  CD_IDA: "IDA",
  DT_PULSO: "Data do Pulso",
  TIPO: "Travado",
  NR_BATERIA: "Nível de carga",
  NR_ORDEM_SERVICO: "Nr. Ordem de Serviço",
  DS_SERVICO: "Descrição Serviço",
}

const initialData = [
  {
    MES: "",
    MAIORPULSO: "",
    MENORPULSO: "",
    DEVICE: "",
    NR_HIDROMETRO: "",
    IDA: "",
    DS_LOCALIDADE: "",
  },
  {
    MES: "",
    MAIORPULSO: "",
    MENORPULSO: "",
    DEVICE: "",
    NR_HIDROMETRO: "",
    IDA: "",
    DS_LOCALIDADE: "",
  },
];

function BarChart() {
  const [parametroUrl, setParametroUrl] = useState("");  
  const location = useLocation();
  const [showInfos, setShowInfos] = useState([]);
  const [showFilterInfos, setShowFilterInfos] = useState([]);
  const [showDisplay, setShowDisplay] = useState("none");
  const [showPulse, setShowPulse] = useState("")
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState({
    ida: undefined,
    hydro: undefined,
    lora: undefined,
    condominio: undefined,
    dateInit: '',
    dateEnd: '',
  });
  const [typeHidro, setTypeHidro] = useState({
    ativo: 0,
    inativo: 0,
    inativo_com_consumo: 0,
    micro_sem_pulso: 0,
  });

  useEffect(() => {
    const queryString = location.search.split("?")[1];

    setParametroUrl(queryString);
    setHidrometro(queryString);
    if (queryString) {
      setSearch({
        ida: undefined,
        hydro: queryString,
      });
      submitHandler(queryString);
    }
  }, [location]);


  const [localidade, setLocalidade] = useState([]);
  const [hidrometro, setHidrometro] = useState("");
  const [ida, setIda] = useState("");
  const [values, setValues] = useState([]);
  const [mes, setMes] = useState([]);
  const [day, setDay] = useState(0);
  const [filter, setFilter] = useState(false)
  const [total2, setTotal2] = useState([]);
  const [total, setTotal] = useState("");
  const [titleAlarm, setTitleAlarm] = useState("");
  const [titleAlarmTipe, setTitleAlarmTipe] = useState("");
  const [isMeter, setIsMeter] = useState(false)
  const [isLora, setIsLora] = useState(false)
  const [dataLora, setDataLora] = useState([])
  const [typeEquip, setTypeEquip] = useState("")
  const [searchType, setSearchType] = useState("Dashboard")
  const [meter, setMeter] = useState({
    MCON_24: 0,
    MCON_12: 0,
    MPULSO_24: 0,
    MPULSO_12: 0,
  });
  const [baterys, setBaterys] = useState({
    status100: 0,
    status80: 0,
    status50: 0,
  });
  const [os,setOs] = useState({
    aberto: 0
  })

  const [alarm, setAlarm] = useState({
    total: 0,
    corte: 0,
    vazamento: 0,
    ataque_magnetico: 0,
    reverso: 0,
  });
  const [loraType, setLoraType] = useState({
    vinculado: 0,
    disponivel: 0
  })
  useEffect(() => {
    alarms();
    meters();
    hidrometerType();
    loras();
    batery();
    ordemServico();
  }, []);
  function resetSearch() {
    resetStates();
    setShowPulse("");
    setTotal("");
    setSearch({
      ida: "",
      hydro: "",
      condominio: "",
      lora: "",
      dateInit: '',
      dateEnd: '',

    });
    setSearchType("Dashboard")
  }
  function resetStates() {
    setIsLoading(true);
    setShowDisplay("none");
    setLocalidade([]);
    setHidrometro("");
    setIda("");
    setValues([]);
    setMes([]);
    setValues([]);
    setDay(0)
    setFilter(false)
    setIsLora(false)
  }

const filterData = async (event) => {
  event.preventDefault();

  const hasCondo = !!search.condominio;
  const hasHydro = !!search.hydro;

  if (!hasCondo && !hasHydro) {
    setShowFilterInfos(showInfos);
    return;
  }

  const filtered = showInfos.filter(info => {
    const condoValue = info.LOCALIDADE?.toLowerCase() || "";
    const hydroValue1 = info.HIDROMETRO?.toLowerCase() || "";
    const hydroValue2 = info.NR_EQUIPAMENTO?.toLowerCase() || "";

    const hasCondo = !!search.condominio;
    const hasHydro = !!search.hydro;

    const condoSearch = search.condominio?.toLowerCase() || "";
    const hydroSearch = search.hydro?.toLowerCase() || "";

    // Se os dois existirem → precisa bater nos dois
    if (hasCondo && hasHydro) {
      return (
        condoValue.includes(condoSearch) &&
        (hydroValue1.includes(hydroSearch) ||
        hydroValue2.includes(hydroSearch))
      );
    }

    // Só condomínio
    if (hasCondo) {
      return condoValue.includes(condoSearch);
    }

    // Só hydro
    if (hasHydro) {
      return (
        hydroValue1.includes(hydroSearch) ||
        hydroValue2.includes(hydroSearch)
      );
    }

    // Nenhum filtro
    return true;
  });

  setShowFilterInfos(filtered);
};
  useEffect(() => {
    setShowFilterInfos(showInfos)
  }, [showInfos]);

  const alarms = async () => {
    await api
      .post("/consumptions/alarm", {
        TYPE: "GERAL",
      })
      .then((response) => {
        let pulso = response.data[0].PULSO_1 + response.data[0].PULSO_2;
        let totalAlarm =
          pulso +
          response.data[0].STATUS_DA_VALVULA +
          response.data[0].ATAQUE_MAGNETICO;

        setAlarm({
          total: totalAlarm,
          corte: pulso,
          vazamento: response.data[0].STATUS_DA_VALVULA,
          ataque_magnetico: response.data[0].ATAQUE_MAGNETICO,
          reverso: response.data[0].REVERSE,
        });
      });
  };

  const meters = async () => {
    await api
      .post("/consumptions/meters", {
        TYPE: "FULL",
      })
      .then((response) => {
        setMeter({
          MCON_24: response.data[0].METERSCON12,
          MCON_12: response.data[0].METERSCON24,
          MPULSO_24: response.data[0].METERSPUL12,
          MPULSO_12: response.data[0].METERSPUL24,
        });
      });
  };
  const loras = async (type = '', NR_EQUIPAMENTO = "") => {
    await api
      .post("/equipmentslora/linked", {
        NR_EQUIPAMENTO: NR_EQUIPAMENTO,
      })
      .then((response) => {
        if (NR_EQUIPAMENTO == "") {
          setDataLora({
            vinculado: response.data.linked,
            disponivel: response.data.notLinked
          })
          setLoraType({
            vinculado: response.data.countLinked,
            disponivel: response.data.countNotLinked
          });
        } else {
          if (type == 'lorasDisponiveis' && response.data.notLinked.length > 0) {
            setShowInfos(response.data.notLinked)
          } else if (type == 'lorasVinculados' && response.data.linked.length > 0) {
            setShowInfos(response.data.linked)
          } else {
            Swal.fire({
              title: "Nenhum resultado encontrado para esta busca!",
              icon: "warning",
            });
          }
        }
      });

  }
  const batery = async () => {
    await api
      .post("/consumptions/Batery", {

        TYPE: "FULL",
      })
      .then((response) => {
        setBaterys({
          status100: response.data.bateria100,
          status80: response.data.bateria80,
          status50: response.data.bateria50
        });
      });
  };
  const ordemServico = async () => {
    await api
      .post("/consumptions/os", {

        TYPE: "FULL",
      })
      .then((response) => {
        setOs({
          aberto: response.data[0]['TOTAL'],         
        });
      });
  };

  const hidrometerType = async () => {
    await api
      .post("/consumptions/hidrometer", {
        TYPE: "FULL",
      })
      .then((response) => {
        setTypeHidro({
          ativo: response.data[0].ATIVOS,
          inativo: response.data[0].INATIVOS,
          inativo_com_consumo: response.data[0].INATIVOS_COM_CONSUMO,
          micro_sem_pulso: response.data[0].MICRO_SEM_PULSO,
        });
      });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (isLoading && showDisplay === 'none') {
        window.location.reload();
      }
    }, 90000);

    return () => {
      clearInterval(interval);
    };
  }, [isLoading, showDisplay]);

  const showMeters = async (filter, hidro = "") => {
    await api
      .post("/consumptions/meters", {
        TYPE: filter,
        NR_HIDROMETRO: hidro,
      })
      .then((response) => {
        if (response.data.length > 0) {
          setShowInfos(response.data);
          setShowDisplay("block");
          // mostrará "sem pulso" ou "travado" a depender do filtro, junto com o tempo do filtro.
          setTitleAlarm("Medidores " + (filter.indexOf('CON') > -1 ? " sem pulso " : " travado ") + filter.match(/\d+/g).join('') + "h");
          setSearchType("Medidores" + filter)

          setTitleAlarmTipe("");
          setTypeEquip("Hidrometro")

          setIsMeter(true)
          setIsLora(false)
        } else {
          Swal.fire({
            title: "Nenhum resultado encontrado para esta busca!",
            icon: "warning",
          });
        }
      });
  };
  const showTypeHidro = async (filter, hidro = '') => {
    await api
      .post("/consumptions/hidrometer", {
        TYPE: filter,
        NR_HIDROMETRO: hidro,
      })
      .then((response) => {
        if (response.data.length > 0) {
          setShowInfos(response.data);
          setShowDisplay("block");
          setIsMeter(false)
          setIsLora(false)
          setTypeEquip("Hidrometro")

          if (filter == "ATIVOS") {
            setTitleAlarm("Hidrometros Ativos");
            setSearchType("hidrometrosAtivos")


          } else if (filter == "INATIVOS") {
            setTitleAlarm("Hidrometros Inativos");
            setSearchType("hidrometrosInativos")
          
          
          } else if (filter == "INATIVOS_COM_CONSUMO") {
            setTitleAlarm("Hidrometros Inativos Com Consumo");
            setSearchType("hidrometrosInativosComConsumo")
          
          
          } else if (filter == "MICRO_SEM_PULSO") {
            setTitleAlarm("Micromedidores sem pulso a mais de 24 horas");
            setSearchType("hidrometrosMicroSemPulso")
          }
          setTitleAlarmTipe("");
        } else {
          Swal.fire({
            title: "Nenhum resultado encontrado para esta busca!",
            icon: "warning",
          });
        }
      });
  };
  const showLoras = async (filter) => {
    setTypeEquip("lora")
    setSearchType("loras")
    setTitleAlarmTipe("")
    if (filter == "vinculados") {
      setSearchType("lorasVinculados")

      setShowInfos(dataLora.vinculado)
      setTitleAlarm("Loras Vinculados")
      setIsLora(false)


    } else {
      setSearchType("lorasDisponiveis")

      setShowInfos(dataLora.disponivel)
      setTitleAlarm("Loras Disponíveis")
      setIsLora(true)


    }
    setShowDisplay("block");
    setIsMeter(false)


  }
  const showAlarms = async (filter, hidro = '') => {
    await api
      .post("/consumptions/alarm", {
        TYPE: filter,
        NR_HIDROMETRO: hidro,
      })
      .then((response) => {
        if (response.data.length > 0) {
          setShowInfos(response.data);
          setShowDisplay("block");
          setIsMeter(false)
          setIsLora(false)
          setTypeEquip("Hidrometro")


          setTitleAlarm("Alarmes das ultimas 12 horas --> ");
          if (filter == "CORTE") {
            setTitleAlarmTipe("Corte de cabo do Pulso");
            setSearchType("alarmesCorte")

          } else if (filter == "VAZAMENTO") {
            setTitleAlarmTipe("Vazamento no Pulso");
            setSearchType("alarmesVazamento")

          } else if (filter == "ATAQUE") {
            setTitleAlarmTipe("Ataque Magnético");
            setSearchType("alarmesAtaque")

          } else if (filter == "REVERSO") {
            setTitleAlarmTipe("Consumo Reverso");
            setSearchType("alarmesReverso")

          }
        } else {
          Swal.fire({
            title: "Nenhum resultado encontrado para esta busca!",
            icon: "warning",
          });
        }
      });
  };

  const showBatery = async (filter, hidro = '') => {
    await api
      .post("/consumptions/batery", {
        TYPE: filter,
        NR_HIDROMETRO: hidro,
      })
      .then((response) => {
        if (response.data.length > 0) {
          setShowInfos(response.data);
          setShowDisplay("block");
          setIsMeter(false)
          setIsLora(false)
          setTypeEquip("Hidrometro")


          if (filter == "100") {
            setTitleAlarm("Baterias de 100% a 80%");
            setSearchType("bateria100")

          } else if (filter == "80") {
            setTitleAlarm("Baterias de 79% a 50%");
            setSearchType("bateria80")

          } else if (filter == "50") {
            setTitleAlarm("Baterias de 49% a 0%");
            setSearchType("bateria50")


          }

          setTitleAlarmTipe("");
        } else {
          Swal.fire({
            title: "Nenhum resultado encontrado para esta busca!",
            icon: "warning",
          });
        }
      });
  };
  const showOs = async (filter) => {
    await api
      .post("/consumptions/os", {
        TYPE: filter
      })
      .then((response) => {
        if (response.data.length > 0) {
          setShowInfos(response.data);
          setShowDisplay("block");
          setIsMeter(false)
          setIsLora(false)
          setTypeEquip("Hidrometro")
          setTitleAlarm("Ordens de serviço");
          setSearchType("Aberto")
          setTitleAlarmTipe("");
        } else {
          Swal.fire({
            title: "Nenhum resultado encontrado para esta busca!",
            icon: "warning",
          });
        }
      });
  };

  const showHidro = async (idHidro) => {
    if (typeEquip == "lora") {
      return
    }

    setHidrometro(idHidro.target.innerHTML);
    setSearch({
      ida: undefined,
      hydro: idHidro.target.innerHTML,
    });
    submitHandler(idHidro.target.innerHTML);
  };

  const submitHandlerPrevent = async (event) => {
    event.preventDefault();
   
    if (searchType == "Dashboard") {
      submitHandler();
    } else if (searchType == "MedidoresMCON_24") {
      showMeters("MCON_24", search.hydro)
    } else if (searchType == "MedidoresMCON_12") {
      showMeters("MCON_12", search.hydro)
    } else if (searchType == "MedidoresMPULSO_24") {
      showMeters("MPULSO_24", search.hydro)
    } else if (searchType == "MedidoresMPULSO_12") {
      showMeters("MPULSO_12", search.hydro)
    } else if (searchType == "hidrometrosAtivos") {
      showTypeHidro("ATIVOS", search.hydro)
    } else if (searchType == "hidrometrosInativos") {
      showTypeHidro("INATIVOS", search.hydro)
    } else if (searchType == "hidrometrosInativosComConsumo") {
      showTypeHidro("INATIVOS_COM_CONSUMO", search.hydro)
    } else if (searchType == "hidrometrosMicroSemPulso") {
      showTypeHidro("MICRO_SEM_PULSO", search.hydro)
    } else if (searchType == "bateria100") {
      showBatery("100", search.hydro)
    } else if (searchType == "bateria80") {
      showBatery("80", search.hydro)
    } else if (searchType == "bateria50") {
      showBatery("50", search.hydro)
    } else if (searchType == "Aberto") {
      showOs("Aberto")
    } else if (searchType == "alarmesVazamento") {
      showAlarms("VAZAMENTO", search.hydro)
    } else if (searchType == "alarmesAtaque") {
      showAlarms("ATAQUE", search.hydro)
    } else if (searchType == "alarmesCorte") {
      showAlarms("CORTE", search.hydro)
    } else if (searchType == "alarmesReverso") {
      showAlarms("REVERSO", search.hydro)
    } else if (searchType == "lorasDisponiveis") {
      loras("lorasDisponiveis", search.hydro)
    } else if (searchType == "lorasVinculados") {
      loras("lorasVinculados", search.hydro)
    }

  };
  const submitHandler = async (idHidro) => {
    if (typeof idHidro == 'string') {

      search.hydro = idHidro;
    }
    if (hidrometro !== undefined || ida !== undefined) {

      await api
        .post("/consumptions/draw", {
          NR_HIDROMETRO: day ? hidrometro : search.hydro,
          IDA: search.ida,
          TYPE: "MES",
          DATE: { "start": search.dateInit ? search.dateInit : "", "end": search.dateEnd ? search.dateEnd : "" }
        })
        .then((response) => {
          let oldValue = 0
          var lastMax = 0;
          var k = 0;
          resetStates();
          let sumPulse = 0
          let countMes = "";
          let consumo = 0
          for (var i = 0; i < response.data.length; i++) {
            if (typeof response.data[i].MENORPULSO == "undefined") {
              response.data[i].MENORPULSO = 0;
            }
            response.data[i].MENORPULSO = Math.trunc(
              response.data[i].MENORPULSO
            );
            response.data[i].MAIORPULSO = Math.trunc(
              response.data[i].MAIORPULSO
            );
            consumo = ((response.data[i].MAIORPULSO - response.data[i].MENORPULSO) > 0 ? (response.data[i].MAIORPULSO - response.data[i].MENORPULSO) : 0)
            if (i === 0) {
              countMes = response.data[i].MES;
              sumPulse = sumPulse + (response.data[i].MAIORPULSO - response.data[i].MENORPULSO)

              setValues((oldState) => [
                ...oldState,
                consumo,
              ]);
              lastMax = response.data[i].MAIORPULSO
              setTotal2(Number(response.data[i].DS_RELOJOARIA_INICIAL));


            } else {
              const dataFiltered = data.slice(0, 2);
              setData(dataFiltered);

              oldValue = (response.data[i].MENORPULSO - lastMax > 0 ? response.data[i].MENORPULSO - lastMax : 0)
              sumPulse = sumPulse + (consumo + oldValue)

              setValues((oldState) => [
                ...oldState,
                (consumo + oldValue),
              ]);
              lastMax = response.data[i].MAIORPULSO
            }

            setMes((oldState) => [...oldState, response.data[i].MES]);



            var d = response.data[i];
            setData((oldState) => [...oldState, d]);
            setIsLoading(false);

          }
          setTotal(response.data[(response.data.length - 1)].MAIORPULSO);
          setHidrometro(response.data[0].NR_HIDROMETRO);
          setIda(response.data[0].IDA);
          setLocalidade(response.data[0].DS_LOCALIDADE);
          search.dateInit ? setShowPulse(sumPulse) : ""
          search.dateInit ? setDay(1) : ""
          search.dateInit ? setFilter(true) : ""

        })
        .catch((error) => {
          let resp = error.response.data.split('*')
          Swal.fire({
            title: resp[1],
            icon: "warning",
          });
        });

    }
  };
  const showDay = async (filter) => {
    await api
      .post("/consumptions/draw", {
        NR_HIDROMETRO: hidrometro,
        IDA: ida,
        TYPE: "DAY",
        MES: filter,
      })
      .then((response) => {
        let oldValue = 0
        var lastMax = 0
        var k = 0;
        resetStates();
        let sumPulse = 0
        let countMes = "";
        let consumo
        for (var i = 0; i < response.data.length; i++) {
          if (typeof response.data[i].MENORPULSO == "undefined") {
            response.data[i].MENORPULSO = 0;
          }
          response.data[i].MENORPULSO = Math.trunc(response.data[i].MENORPULSO);
          response.data[i].MAIORPULSO = Math.trunc(response.data[i].MAIORPULSO);
          consumo = ((response.data[i].MAIORPULSO - response.data[i].MENORPULSO) > 0 ? (response.data[i].MAIORPULSO - response.data[i].MENORPULSO) : 0)

          if (i === 0) {
            response.data[i].MENORPULSO = Math.trunc(
              response.data[i].MENORPULSO
            );
            response.data[i].MAIORPULSO = Math.trunc(
              response.data[i].MAIORPULSO
            );
            countMes = response.data[i].MES;
            sumPulse = sumPulse + consumo
            setValues((oldState) => [
              ...oldState,
              consumo
            ]);
            lastMax = response.data[i].MAIORPULSO
            setTotal2(Number(response.data[i].DS_RELOJOARIA_INICIAL));


          } else {
            const dataFiltered = data.slice(0, 2);
            setData(dataFiltered);
            oldValue = (response.data[i].MENORPULSO - lastMax > 0 ? response.data[i].MENORPULSO - lastMax : 0)
            sumPulse = sumPulse + (consumo + oldValue)

            setValues((oldState) => [
              ...oldState,
              (consumo + oldValue),
            ]);
            lastMax = response.data[i].MAIORPULSO
          }

          setMes((oldState) => [...oldState, response.data[i].MES]);

          var d = response.data[i];
          setData((oldState) => [...oldState, d]);
          setIsLoading(false);
          setDay(1);

        }
        setHidrometro(response.data[0].NR_HIDROMETRO);
        setIda(response.data[0].IDA);
        setLocalidade(response.data[0].DS_LOCALIDADE);
        search.dateInit ? setShowPulse(sumPulse) : ""
      })
      .catch((error) => {
        let resp = error.response.data.split('*')
        Swal.fire({
          title: resp[1],
          icon: "warning",
        });
      });
  };
  const showHour = async (filter) => {
    await api
      .post("/consumptions/draw", {
        NR_HIDROMETRO: hidrometro,
        IDA: ida,
        TYPE: "HOUR",
        MES: filter,
      })
      .then((response) => {
        var k = 0;
        resetStates();
        let sumPulse = 0
        let countMes = "";
        for (var i = 0; i < response.data.length; i++) {

          countMes = response.data[i].MES;
          sumPulse = sumPulse + (response.data[i].valor)
          setValues((oldState) => [
            ...oldState,
            response.data[i].valor,
          ]);
          setMes((oldState) => [...oldState, response.data[i].MES]);
          if (k > 0) {
            var d = response.data[i];
            setData2((oldState) => [...oldState, d]);
          } else {
            var d = response.data[i];
            setData((oldState) => [...oldState, d]);
            setIsLoading(false);
            setDay(2);
          }
        }
        setTotal2(Number(response.data[0].DS_RELOJOARIA_INICIAL));
        setHidrometro(response.data[0].NR_HIDROMETRO);
        setIda(response.data[0].IDA);
        setLocalidade(response.data[0].DS_LOCALIDADE);

      })
      .catch((error) => {
        Swal.fire({
          title: error,
          icon: "warning",
        });
      });
  };
  const onChangeHandler = (prop) => (event) => {
    setSearch((oldState) => ({ ...oldState, [prop]: event.target.value }));
  };
  const chartData = {
    labels: mes,
    datasets: [
      {
        label: "teste",
        backgroundColor: "#02a499",
        borderColor: "#02a499",
        borderWidth: 1,
        borderRadius: 50,
        barPercentage: 0.6,
        hoverBackgroundColor: "#11f0e1ff",
        hoverBorderColor: "#11f0e1ff",
        data: values,
        total: sum(values),
      },
    ],
  };

  const option = {
    tootlbar: {
      show: false,
    },
 responsive: true,
  plugins: {
    legend: {
      display: true,
    },
  },
    legend: {
      display: false,
    },

    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var total = dataset.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat(
            ((currentValue / total) * 100).toFixed(1)
          );
          return currentValue + " (" + percentage + "%)";
        },
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        },
      },
    },
    onClick: function (event, element) {
      if (element.length == 0) {
      } else {
        if (day == 0 && filter == false) {
          showDay(element[0]._model.label);
        } if (day == 1) {
          showHour(element[0]._model.label)

        }
      }
    },
  };




  return (
    <>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <form onSubmit={searchType == "Dashboard" ? submitHandlerPrevent : filterData} name="formDrawn">
                <table className="table table-condensed table-responsive">
                  <tbody>
                    <tr>
                      <td className="col-sm-6 col-centered leftCol">
                        <div className="col-md-6">
                          <Row className="mb-2">
                            <label
                              htmlFor="codigo"
                              className="col-md-12 col-form-label"
                            >
                              {isLora ? "Lora" : "Hidrômetro"}
                            </label>
                            <div className="col-md-12">
                              <Input
                                className="form-control form-control-lg"
                                type="text"
                                onChange={onChangeHandler("hydro")}
                                value={search.hydro}
                              />
                            </div>
                          </Row>
                          <Row className="mb-2" style={{ display: searchType == "hidrometrosMicroSemPulso" ? "block" : "none" }}>
                            <label
                              htmlFor="codigo2"
                              className="col-md-12 col-form-label"
                            >
                              Condomínio
                            </label>
                            <div className="col-md-12">
                              <Input
                                className="form-control form-control-lg"
                                type="text"
                                onChange={onChangeHandler("condominio")}
                                value={search.condominio}
                              />
                            </div>
                          </Row>
                          <Row className="mb-2" style={{ display: searchType == "Dashboard" ? "block" : "none" }}>
                            <label
                              htmlFor="codigo2"
                              className="col-md-12 col-form-label"
                            >
                              IDA
                            </label>
                            <div className="col-md-12">
                              <Input
                                className="form-control form-control-lg"
                                type="text"
                                onChange={onChangeHandler("ida")}
                                value={search.ida}
                              />
                            </div>
                          </Row>
                          <div className="col-md-12 d-flex justify-content-sm-left" >
                            <Row className="mb-2 col-md-6" style={{ display: searchType == "Dashboard" ? "block" : "none" }}>

                              <div className="col-md-12">
                                <label
                                  htmlFor="codigo2"
                                  className="col-md-12 col-form-label"
                                >
                                  Data Início
                                </label>
                                <div className="col-md-10">
                                  <Input
                                    className="form-control form-control-lg"
                                    type="date"
                                    onChange={onChangeHandler("dateInit")}
                                    value={search.dateInit}
                                  />
                                </div>
                              </div>
                            </Row>
                            <Row className="mb-2 col-md-6" style={{ display: searchType == "Dashboard" ? "block" : "none" }}>
                              <div className="col-md-12">
                                <label
                                  htmlFor="codigo2"
                                  className="col-md-6 col-form-label"
                                >
                                  Data Final
                                </label>
                                <div className="col-md-10">
                                  <Input
                                    className="form-control form-control-lg"
                                    type="date"
                                    onChange={onChangeHandler("dateEnd")}
                                    value={search.dateEnd}
                                  />
                                </div>
                              </div>
                            </Row>
                          </div>
                          <div className="col-md-12 d-flex justify-content-sm-center">
                            <Row className="mb-2 col-md-6">

                              <div className="align-items-center">

                                <div>
                                  <h4 className="mb-0 font-size-20">
                                    {total !== "" ? "Leitura Atual" : ""}
                                  </h4>
                                </div>
                                <h5
                                  className="mb-0 font-size-20"
                                  style={{ color: "#0057AA" }}
                                >
                                  {total !== "" ? parseInt(total + total2) + " M³" : ""}
                                </h5>
                              </div>
                            </Row>
                            <Row className="mb-2 col-md-6">

                              <div className="align-items-center col-md-6">

                                <div className="col-md-12">
                                  <h4 className="mb-0 font-size-20">
                                    {showPulse !== "" ? "Consumo Período" : ""}
                                  </h4>
                                </div>
                                <h5
                                  className="mb-0 font-size-20 align-items-center"
                                  style={{ color: "#0057AA" }}
                                >
                                  {showPulse !== "" ? parseInt(showPulse) + " M³" : ""}
                                </h5>
                              </div>
                            </Row>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <Row className="mb-2">
                  <div className="button-items text-center">
                    <Button color="secondary" className="btn-lg" type="submit">
                      Pesquisar
                      <i className="dripicons-search" />
                    </Button>
                  </div>
                </Row>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {isLoading ? (
        <>
          {showDisplay == "none" ? (

            <>
            <div style={{ overflow: "hidden", width: "100%" }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                 <div style={{ display: "flex" }}>
                    <div
                      className="col-md-12"
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        borderRadius: 5,
                        width:300
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                          backgroundColor: "#CEEBEF",
                        }}
                      >
                        <div
                          className="font-size-18 col-md-12"
                          style={{ fontWeight: "bold", fontSize: "xx-large" }}
                        >
                          Alertas 12 Horas <i className="ti-alarm-clock"></i>
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                            onClick={() => showAlarms("CORTE")}
                            title="Alerta de corte de pulso"
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Corte de pulso
                            </div>
                            <div><b>{alarm.corte}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showAlarms("VAZAMENTO")}
                          title="Alerta de possível vazamento"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Possível vazamento
                            </div>
                            <div><b>{alarm.vazamento}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showAlarms("ATAQUE")}
                          title="Alerta de ataque magnético"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Ataque magnético
                            </div>
                            <div><b>{alarm.ataque_magnetico}</b></div>
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              borderWidth: 0.1,
                              borderStyle: "solid",
                              borderColor: "#F6F6F8",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                padding: 15,
                              }}
                              onClick={() => showAlarms("REVERSO")}
                              title="Alerta de consumo reverso"
                            >
                              <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Consumo Reverso

                              </div>
                              <div><b>{alarm.reverso}</b> </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      borderWidth: 0.1,
                      borderStyle: "solid",
                      borderColor: "#F6F6F8",
                      borderRadius: 5,

                    }}
                  >
                    <div
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        padding: 15,
                        backgroundColor: "#CEEBEF",
                        width:300
                      }}
                    >
                      <div
                        className="font-size-18 col-md-12"
                        style={{ fontWeight: "bold", fontSize: "xx-large" }}
                      >
                        Medidores
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                          }}
                          onClick={() => showMeters("MCON_24")}
                          title="Medidores com pulso travado a mais de 24 horas"
                        >
                          <div style={{ fontWeight: "bold", fontSize: "large", whiteSpace: "nowrap"  }}>
                            Travado há 24 horas

                          </div>
                          <div><b>{meter.MCON_24}</b></div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                          }}
                          onClick={() => showMeters("MCON_12")}
                          title="Medidores com pulso travado a 12 horas"
                        >
                          <div style={{ fontWeight: "bold", fontSize: "large", whiteSpace: "nowrap"  }}>
                            Travado há 12 horas

                          </div>
                          <div><b>{meter.MCON_12}</b></div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                          }}
                          onClick={() => showMeters("MPULSO_24")}
                          title="Medidores sem pulso a 24 horas"
                        >
                          <div style={{ fontWeight: "bold", fontSize: "large", whiteSpace: "nowrap"  }}>
                            Sem pulso há 24 horas

                          </div>
                          <div><b>{meter.MPULSO_24}</b></div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          borderWidth: 0.1,
                          borderStyle: "solid",
                          borderColor: "#F6F6F8",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: 15,
                          }}
                          onClick={() => showMeters("MPULSO_12")}
                          title="Medidores sem pulso a de 12 horas"
                        >
                          <div style={{ fontWeight: "bold", fontSize: "large", whiteSpace: "nowrap"  }}>
                            Sem pulso há 12 horas

                          </div>
                          <div><b>{meter.MPULSO_12}</b></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className="col-md-12"
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        borderRadius: 5,
                        width: 400,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                          backgroundColor: "#CEEBEF",
                        }}
                      >
                        <div
                          className="font-size-18 col-md-12"
                          style={{ fontWeight: "bold", fontSize: "xx-large" }}
                        >
                          Hidrometros
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                            onClick={() => showTypeHidro("ATIVOS")}
                            title="Hidrometros Ativos"
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Hidrometros Ativos
                            </div>
                            <div><b>{typeHidro.ativo}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showTypeHidro("INATIVOS")}
                          title="Hidrometros Inativos"

                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Hidrometros Inativos
                            </div>
                            <div><b>{typeHidro.inativo}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showTypeHidro("MICRO_SEM_PULSO")}
                          title="Micromedidores sem pulso a 24 horas"

                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Micromedidores sem pulso a 24 horas
                            </div>
                            <div><b>{typeHidro.micro_sem_pulso}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showTypeHidro("INATIVOS_COM_CONSUMO")}
                          title="Hidrometros Inativos com consumo"

                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                            Hidrometros Inativos com consumo
                            </div>
                            <div><b>{typeHidro.inativo_com_consumo}</b></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                  <div style={{ display: "flex" }}>
                    <div
                      className="col-md-12"
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        borderRadius: 5,
                        width:300
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                          backgroundColor: "#CEEBEF",
                        }}
                      >
                        <div
                          className="font-size-18 col-md-12"
                          style={{ fontWeight: "bold", fontSize: "xx-large" }}
                        >
                          Loras
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                            onClick={() => showLoras("disponiveis")}
                            title="Disponíveis"
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Disponíveis
                            </div>
                            <div><b>{loraType.disponivel}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showLoras("vinculados")}
                          title="Vinculados"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Vinculados

                            </div>
                            <div><b>{loraType.vinculado}</b></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className="col-md-12"
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        borderRadius: 5,
                        width:300
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                          backgroundColor: "#CEEBEF",
                        }}
                      >
                        <div
                          className="font-size-18 col-md-12"
                          style={{ fontWeight: "bold", fontSize: "xx-large" }}
                        >
                          Baterias
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                            onClick={() => showBatery("100")}
                            title=" Baterias de 80% a 100% de carga"

                          >
                            <div style={{ fontWeight: "bold", fontSize: "large", color: "#228B22" }}>
                              80% a 100%
                            </div>
                            <div><b>{baterys.status100}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showBatery("80")}
                          title=" Baterias de 50% a 79% de carga"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large", color: "#00FF7F" }}>
                              50% a 79%
                            </div>
                            <div><b>{baterys.status80}</b></div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showBatery("50")}
                          title=" Baterias de 0% a 49% de carga"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large", color: "#f8722d" }}>
                              0% a 49%
                            </div>
                            <div><b>{baterys.status50}</b></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  <div style={{ display: "flex" }}>
                    <div
                      className="col-md-12"
                      style={{
                        borderWidth: 0.1,
                        borderStyle: "solid",
                        borderColor: "#F6F6F8",
                        borderRadius: 5,
                        width:400
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          padding: 15,
                          backgroundColor: "#CEEBEF",
                        }}
                      >
                        <div
                          className="font-size-18 col-md-12"
                          style={{ fontWeight: "bold", fontSize: "xx-large" }}
                        >
                          Ordens de Serviço
                        </div>
                      </div>
                      <div>                                        
                        <div
                          style={{
                            borderWidth: 0.1,
                            borderStyle: "solid",
                            borderColor: "#F6F6F8",
                          }}
                          onClick={() => showOs("Aberto")}
                          title=" Baterias de 0% a 49% de carga"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              padding: 15,
                            }}
                          >
                            <div style={{ fontWeight: "bold", fontSize: "large" }}>
                              Em aberto
                            </div>
                            <div><b>{os.aberto}</b></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </>
          ) : (
            <></>
          )}
          <div style={{ display: showDisplay }}>
            <div>
              <div className="col-sm-12 mb-2 card-title d-flex justify-content-center">
                <span className="font-weight-bold font-size-18 h2 mt-4 card-title">
                  {titleAlarm}
                </span>
                <span className="font-weight-normal card-title">
                  {titleAlarmTipe}
                </span>
              </div>
            </div>
            <div className="col-sm-12 mb-2 card-title d-flex justify-content-start">
              <button className="btn btn-link ml-2" onClick={resetSearch}>
                <i className="ti-arrow-left" style={{ fontSize: "24px" }}></i>

              </button>
              <div style={{ display: typeEquip == "lora" ? "none" : "block" }}  >

          
                <div className="col-md-12 d-flex " style={{ display: showDisplay }}>
                  <Row className="col-md-10">
                    <br></br>
                    <ExcelDmae data={showFilterInfos} name={titleAlarm + titleAlarmTipe} columns={columnsLabel} allColumns={false}/>

                  </Row>
                </div>

              </div>


            </div>

            <div className="table-responsive">
              <table className="table align-middle table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    {showInfos[0]?.NR_ORDEM_SERVICO ? <td>Nr. Ordem de Serviço</td> : null}
                    {showInfos[0]?.DS_SERVICO ? <td>Descrição Serviço</td> : null}

                    {isLora ? <th className="align-middle w-25">Status</th> : null}
                    {(showInfos[0]?.HIDROMETRO) ? <td>Hidrometro</td> : null}
                    {(showInfos[0]?.CD_IDA) ? <td>IDA</td> : null}

                      
                    {(showInfos[0]?.NR_EQUIPAMENTO) ? <td>Número Equip. Lora</td> : null}
                    {showInfos[0]?.LOCALIDADE ? <td>Localidade</td> : null}
                    {showInfos[0]?.APARTAMENTO ? <td>Apartamento</td> : null}


                    {isMeter ? <th className="align-middle">Travado</th> : null}
                    {showInfos[0]?.NR_BATERIA ? <td>Nível de carga</td> : null}
                    {showInfos[0]?.DT_PULSO ? <td>Ultimo Pulso</td> : null}



                  </tr>
                </thead>
                <tbody>
                  {showFilterInfos?.map((element, key) => (
                    <tr key={"_tr_" + key}>
                      {element.NR_ORDEM_SERVICO ? <td>{element.NR_ORDEM_SERVICO} </td> : null}
                      {element.DS_SERVICO ? <td>{element.DS_SERVICO} </td> : null}
                      {isLora ? <td> {element.PULSOS > 0 ? (
                        <span className="badge bg-success">Registrado</span>
                      ) : (
                        <span className="badge bg-danger bg-primary">
                          Não Registrado
                        </span>
                      )}</td> : null}
                      {(element.HIDROMETRO) ? <td onClick={showHidro}>{element.HIDROMETRO} </td> : null}
                      {(element.CD_IDA) ? <td>{element.CD_IDA} </td> : null}

                      {(element.NR_EQUIPAMENTO) ? <td>{element.NR_EQUIPAMENTO} </td> : null}

                      {element.LOCALIDADE ? <td>{element.LOCALIDADE} </td> : null}
                      {element.APARTAMENTO ? <td>{element.APARTAMENTO} </td> : null}
                      {isMeter ? <td>{element.TIPO} </td> : null}
                      {element.NR_BATERIA ? <td>{element.NR_BATERIA} </td> : null}
                      {element.DT_PULSO ? <td>{element.DT_PULSO} </td> : null}

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <>
          {day ? (
            <>
              <div className="col-sm-12 mb-2 card-title d-flex justify-content-start">
                <button className="btn btn-link ml-2" onClick={submitHandler}>
                  <i className="ti-arrow-left" style={{ fontSize: "24px" }}></i>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="col-sm-12 mb-2 card-title d-flex justify-content-start">
                <button className="btn btn-link mr-2" onClick={resetSearch}>
                  <i className="ti-arrow-left" style={{ fontSize: "24px" }}></i>
                </button>
              </div>
            </>
          )}

          <Row className="justify-content-center">
            <Col sm={4}>
              <div className="text-center">
                <h5 className="mb-0 font-size-20">{ida}</h5>
                <p className="text-muted">I.D.A</p>
              </div>
            </Col>
            <Col sm={4}>
              <div className="text-center">
                <h5 className="mb-0 font-size-20">{hidrometro}</h5>
                <p className="text-muted">HIDROMETRO</p>
              </div>
            </Col>
            <Col sm={4}>
              <div className="text-center">
                <h5 className="mb-0 font-size-20">{localidade}</h5>
                <p className="text-muted">Endereço</p>
              </div>
            </Col>
          </Row>
          <Bar width={600} height={245} data={chartData} options={option} />
          {/*<Line width={600} height={245} data={chartData} options={option} />*/}

        </>
      )}
    </>
  );
}

export default BarChart;
